import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
export function ProblemSection() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5
      }
    }
  };
  return <section className="w-full py-20 md:py-24 px-4 bg-light-coral" data-id="element-199">
      <div className="max-w-3xl mx-auto" data-id="element-200">
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} variants={containerVariants} className="flex flex-col space-y-6" data-id="element-201">
          <motion.h2 variants={itemVariants} className="text-3xl md:text-4xl font-heading font-bold text-text-heading mb-8 text-center" data-id="element-202">
            EL PROBLEMA
          </motion.h2>

          <div className="space-y-6 text-lg md:text-xl text-text-body font-medium" data-id="element-203">
            <motion.p variants={itemVariants} data-id="element-204">Son las 8 de la noche.</motion.p>
            <motion.p variants={itemVariants} data-id="element-205">El plato está servido.</motion.p>
            <motion.p variants={itemVariants} data-id="element-206">
              Cocinaste especialmente para él. O pusiste lo de siempre porque ya
              sabés que lo nuevo no va a funcionar.
            </motion.p>
            <motion.p variants={itemVariants} className="text-secondary-coral font-bold italic" data-id="element-207">
              Pero algo en tu cabeza dice: ¿Hoy va a comer algo?
            </motion.p>
            <motion.p variants={itemVariants} data-id="element-208">
              Mirás su cara. Y esperás.
            </motion.p>

            <div className="h-4" data-id="element-209"></div>

            <motion.p variants={itemVariants} data-id="element-210">
              Esa sensación no es normal. No debería ser parte de tu noche.
            </motion.p>
            <motion.p variants={itemVariants} data-id="element-211">
              Pero se convirtió en tu rutina.
            </motion.p>

            <div className="h-4" data-id="element-212"></div>

            <motion.p variants={itemVariants} className="font-bold text-text-heading" data-id="element-213">
              Y cuando algo sale mal, sabés exactamente lo que viene:
            </motion.p>
          </div>

          <motion.ul variants={containerVariants} className="mt-8 space-y-4 bg-white/60 p-6 md:p-8 rounded-2xl shadow-sm border border-secondary-coral-light/30" data-id="element-214">
            {['El llanto que empieza antes de probar nada', 'La tablet que aparece como única solución', 'El "no me gusta" sin haber tocado el plato', 'Las horas perdidas cocinando lo que termina en la basura', 'Tu energía agotada antes de que termine la semana', 'La culpa que te acompaña cuando se va a dormir con poco en la panza'].map((item, i) => <motion.li key={i} variants={itemVariants} className="flex items-start" data-id="element-215">
                <XIcon className="w-6 h-6 text-secondary-coral mr-3 flex-shrink-0 mt-0.5" data-id="element-216" />
                <span className="text-lg text-text-heading" data-id="element-217">{item}</span>
              </motion.li>)}
          </motion.ul>

          <div className="mt-12 space-y-4 text-center text-lg md:text-xl pt-8" data-id="element-218">
            <motion.p variants={itemVariants} className="font-bold text-text-heading" data-id="element-219">
              ¿Cuánto te costó eso el año pasado?
            </motion.p>
            <motion.p variants={itemVariants} className="text-secondary-coral" data-id="element-220">
              En tiempo. En energía. En paciencia. En vínculo familiar.
            </motion.p>
            <motion.p variants={itemVariants} className="font-bold" data-id="element-221">
              Si sos honesta/o... sabés que demasiado.
            </motion.p>
          </div>
        </motion.div>
      </div>
    </section>;
}